import React, { useEffect } from 'react';
import { selectTaskByCurrentBuilds } from '@redux/selectors/userSelectors.ts';
import { useAppSelector } from '@redux/store';

import { useGetMyInfoMutation } from '@/api/queries/user';

import { NextBuildItem } from './NextBuildItem';
const PageNextBuild: React.FC = () => {
  const taskItem = useAppSelector(selectTaskByCurrentBuilds);
  const [getMyInfo] = useGetMyInfoMutation();

  // it's need for get new nextBuild tasks
  useEffect(() => {
    if (!taskItem) getMyInfo();
  }, [taskItem]);

  return taskItem ? (
    <NextBuildItem {...taskItem} />
  ) : (
    <div className="flex-1"></div>
  );
};

export default PageNextBuild;
